export const normaliseKey = k => {
    // Support the alternative remote codes
    switch (k) {
      case "UP":    return "ArrowUp";
      case "DOWN":  return "ArrowDown";
      case "LEFT":  return "ArrowLeft";
      case "RIGHT": return "ArrowRight";
      default:      return k;
    }
  };
